import React from 'react';
import { useTranslationContext } from "../context/TranslationsProvider";

const Tooltip = ({ isVisible, content }) => {
    const { translations } = useTranslationContext();
    const t = (key, fallback) => translations[key] || fallback;
  return (
    <div className={`tooltip ${isVisible ? 'visible' : ''}`} role="tooltip">
      <div className="tooltip-content">
        {t('bdo-libranza-tooltip-insurance', content)}
      </div>
      <div className="tooltip-arrow"></div>
    </div>
  );
};

export default Tooltip;
